import { useOrgUsageQuery } from './queries';

export function TopUpWallet({ orgId }: { orgId: string | null }) {
  // Org-scoped read (AIT-43): reserve comes from GET /organizations/:orgId/usage
  // (cache-shared with the plans meter), so the wallet renders without an
  // active workspace.
  const usage = useOrgUsageQuery(orgId).data ?? null;
  if (!usage) return null;
  const { reserveBalance, reserveExpiresAt, overflowMode } = usage;
  // AIT-420: name the org's own meter. Absent (pre-v2 backend) reads as messages.
  const unit = usage.usageUnit === 'actions' ? 'actions' : 'messages';
  if (reserveBalance <= 0 && overflowMode !== 'auto_top_up') return null;

  // Footer reflects the actual state: when automated billing is off the reserve
  // is held (not consumed) until it is turned back on; the engine only draws it
  // down on the top-up path. Be honest so we don't imply they keep flowing.
  const footer =
    overflowMode === 'auto_top_up'
      ? 'Top-ups are added automatically when you run low.'
      : overflowMode === 'none'
        ? 'You still have these, even with automated billing off. They are used once you turn it back on.'
        : 'You still have these from earlier top-ups.';

  return (
    <section className="rounded-[20px] border p-5 shadow-[0_12px_28px_0_rgba(0,0,0,0.2),0_2px_4px_0_rgba(0,0,0,0.1)]">
      <h3 className="text-sm font-semibold">Top-up balance</h3>
      <p className="text-2xl font-semibold">{reserveBalance.toLocaleString()} {unit}</p>
      {reserveExpiresAt && (
        <p className="text-xs text-muted-foreground">
          Oldest expires {new Date(reserveExpiresAt).toLocaleDateString()}
        </p>
      )}
      <p className="mt-3 text-xs text-muted-foreground">{footer}</p>
    </section>
  );
}
